// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2lJ0v","head":"Table_head__2QPrF","col":"Table_col__3jwv4"};